import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { Checkbox } from '@zocdoc-frontend-common/components-checkbox';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

export class AgeWarningConfirmationView extends Component {
    static propTypes = {
        invalidMessage: PropTypes.string,
        onCheck: PropTypes.func.isRequired,
        trackClickAgeWarning: PropTypes.func.isRequired,
    };

    renderMessage = () => {
        const { invalidMessage } = this.props;

        if (invalidMessage && invalidMessage.defaultMessage) {
            return invalidMessage.defaultMessage;
        }

        return invalidMessage;
    };

    render() {
        const {
            isChecked,
            onCheck,
            trackClickAgeWarning,
            ageRequirementText,
        } = this.props;

        return (
            <FormRow>
                <Checkbox
                    checked={isChecked}
                    invalidMessage={this.renderMessage()}
                    onChecked={value => {
                        onCheck(value);
                        trackClickAgeWarning();
                    }}
                >
                    <Confirmation data-test="age-requirement-text">
                        {ageRequirementText}
                    </Confirmation>
                </Checkbox>
            </FormRow>
        );
    }
}

const Confirmation = styled.span`
    font: 13px/20px ${FontFamily.SharpSansMedium};
`;
